export default __webpack_public_path__ + "static/media/Swimmer.42562baf.svg";